import { ratingActions } from '../actions';

export default function rating ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case ratingActions.SET_RATING: return generalRatingReducer( newState, action );
        default: return newState;
    }
}

function generalRatingReducer ( newState, action ) {
    delete action.type;
    newState = Object.assign( {}, { ...action } );
    return newState;
}



// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/rating.js